import React from "react";
import { BrowserRouter, Switch, Route } from "react-router-dom";
import Quiz from './pages/Quiz';

function App() {
  return (
    <BrowserRouter>
      <Switch>
        <Route path="/">
          <Quiz />
        </Route>
      </Switch>
    </BrowserRouter>
  );
}

export default App;
